// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__FPjRa","LoginCard":"Card_LoginCard__3kPD8"};